module.exports = __webpack_public_path__ + "img/ai01.046885af.png";